export default (method) => {
    return new Promise(method);
};



// WEBPACK FOOTER //
// ./map/utils/promiseFactory.js